import LeasingOrFinanceQuestionAnswer from "./LeasingOrFinanceQuestionAnswer";

export default LeasingOrFinanceQuestionAnswer;
